/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import React from 'react';
import { PlayCircleTwoTone } from '@ant-design/icons';
import classNames from 'classnames';
import styles from './LearningMethod.module.less';

interface ILearningMethodProps {
  header?: string;
  body: string;
  showTryNow?: boolean;
  onClick?: () => void;
}

function LearningMethod(props: ILearningMethodProps) {
  const { header, body, showTryNow, onClick } = props;

  return (
    <div
      className={styles.learningMethod}
      onClick={onClick}
      data-cy="learning-method"
    >
      {header && (
        <div className={styles.learningMethodHeader}>
          <div>{header}</div>
          {showTryNow && (
            <PlayCircleTwoTone
              className={classNames(
                styles.tryNowButton,
                'learning-method-try-now'
              )}
              data-cy="learning-method-try-now"
            />
          )}
        </div>
      )}
      <div className={styles.learningMethodBody}>{body}</div>
    </div>
  );
}

export default LearningMethod;
